import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import ResponseResultsView from '@/views/response_results_view';
import DialogInterface from '@/interfaces/dialog';
import ConfirmationDialog from '@/views/dialogs/confirmation';
import template from '@/../templates/ide-device-item-view.hbs';

var globalCh = Radio.channel('global');
var alertsCh = Radio.channel('alerts');
var apiCh = Radio.channel('api');

const SHOW_DEFAULTS = Object.freeze({
    type: false,
    rel_owner: true,
    rel_account: true,
    rel_product: true,
    rel_devicegroup: true,
    last_enrolled: true,
    actions: true,
    action_unassign: true,
    action_delete: true,
    action_assign: true,
    action_edit: true,
    action_code: true,
    action_restart: true,
    action_conditional_restart: true,
});

var response_dialog = ResponseResultsView.extend(DialogInterface);
export default Marionette.View.extend({
    template : Handlebars.compile(template),
    ui: {
        name: '.name',
        device_select: '.device-select',
        code_icon: '.show-code-editor',
        settings: '.settings',
        edit_device: '.show-settings',
        assign: '.assign-device',
        unassign: '.unassign-device',
        delete_device: '.delete-device',
        remove_dut: '.remove-dut',
        restart: '.restart',
        conditional_restart: '.conditional-restart',
        tooltips: '[data-toggle="tooltip"]'
    },

    events: {
        'click @ui.name': 'onClickDevice',
        'click @ui.owner': 'onClickDevice',
        'click @ui.device_select': 'onClickDevice',
        'click @ui.code_icon': 'onClickDevice',
        'click @ui.settings': 'showActions',
        'click @ui.edit_device': 'edit_device',
        'click @ui.restart': 'restart_device',
        'click @ui.conditional_restart': 'conditional_restart_device',
        'click @ui.unassign': 'unassign_device',
        'click @ui.remove_dut': 'remove_dut',
        'click @ui.delete_device': 'confirm_delete_device',
        'click @ui.assign': 'show_move_devices_dialog'
    },

    onClickDevice: function() {
        this.triggerMethod('show:device', this.model);
    },

    edit_device: function() {
        globalCh.request('show_device_settings_dialog', this.model);
    },
    unassign_device: function(e) {
        var self = this;
        var success_message = 'Successfully unassigned ';
        this.model.unassign()
            .done(self.on_success(e, success_message))
            .fail(function (e) { self.on_error(e); });
    },
    confirm_delete_device: function () {
        var confirmation_dialog = new ConfirmationDialog({
            callback: this.delete_device.bind(this),
            message: {
                title: 'Delete Device',
                target: this.model.get('name') || this.model.id,
                body: 'You are about to delete device ' + (this.model.get('name') || this.model.id) + '.<br>' +
                'This device will remain offline until configured again using BlinkUp™',
                primary_action: 'Delete'
            }
        });

        globalCh.request('showDialog', confirmation_dialog);
    },
    delete_device: function () {
        this.model.destroy({ wait: true })
            .done(function () {
                alertsCh.request('showAlert', { message: 'Deleted ' + this.model.type + ' ' + this.model.id, messageType: 'success' });
            }.bind(this))
            .fail(function (response) {
                globalCh.request('showDialog', new response_dialog({ resp: response }));
            }.bind(this));
    },
    restart_device: function(e){
            var self = this;
            var success_message = 'Successfully restarted ';
            this.ui.restart.find('.fa').removeClass('fa-power-off').addClass('fa-spinner fa-pulse');
            this.model.restart()
                    .done(self.on_success(e, success_message))
                    .fail( function(e){ self.on_error(e); });
    },
    remove_dut: function(e) {
        var self = this;
        var success_message = 'Successfully removed ';
        this.model.unassign()
            .done(self.on_success(e, success_message))
            .fail(function (e) { self.on_error(e); });
    },
    conditional_restart_device: function(e){
        var self = this;
        var success_message = 'Successfully sent conditional restart message to ';
        this.ui.conditional_restart.find('i.fa').removeClass('fa-power-off').addClass('fa-pulse fa-spinner');
        this.model.conditional_restart()
                    .done(self.on_success(e, success_message))
                    .fail( function(e){ self.on_error(e); });
    },
    show_move_devices_dialog: function () {
        globalCh.request('show_move_devices_dialog', {
            device_ids: [this.model.id],
            omitted_types: ["pre_production_devicegroup", "production_devicegroup", "factoryfixture_devicegroup"],
            selected_devicegroup: this.model.rel.get('devicegroup'),
            selected_product: this.model.rel.get('product'),
        });
    },
    on_success: function(e, success_message){
        $(e.currentTarget).find('.fa').removeClass('fa-spinner fa-pulse').addClass('fa-power-off');
        var name_or_id = this.model.get('name') || this.model.id;
        alertsCh.request('showAlert', { message: success_message + this.model.type + ' ' + name_or_id, messageType: 'success'});
    },
    on_error: function(e){
        $(e.currentTarget).find('.fa').removeClass('fa-spinner fa-pulse');
        globalCh.request('showDialog', new response_dialog({ resp : e }));
    },
    initialize: function() {
        var Accounts = apiCh.request('account');
        // Try the v4 way of finding owner first, fall back to v5
        var rel_owner = this.model.rel.get('owner');
        var owner_id = this.model.get('owned_by')
            || rel_owner && rel_owner.id;
        this.owner = Accounts.get(owner_id);

        this.listenTo(this.model, 'change:name', this.render);
        this.listenTo(this.owner, 'change sync', this.render);

        globalCh.on('selection', this.maybeSetSelection, this);
    },
    onRender: function() {
        this.$el.attr('id', this.model.id);
        this.ui.tooltips.tooltip();
        
        var selection = globalCh.request('selection');
        this.maybeSetSelection(selection);
    },
    modelEvents: {
        'change' : 'render'
    },
    // Event Handlers
    maybeSetSelection: function(selection) {
        if (!selection || (selection.type !== 'device' && selection.type !== 'v5_device')) {
            return;
        }

        var selected = (selection.id === this.model.id);
        this.setSelected(selected);
    },
    setSelected: function(selected) {
        (selected)
            ? this.$el.addClass('active')
            : this.$el.removeClass('active');
    },

    showActions: function(){
        this.$el.toggleClass('actions-on');
    },

    serializeData: function(){
        var data = Marionette.View.prototype.serializeData.call(this);

        var Accounts = apiCh.request('account');
        // determine the username of the device owner, if not it should
        // be simply 'unknown'
        data.owner = 'unknown';
        data.currentUser = false;
        if (this.owner) {
            data.owner = this.owner.get('username');
            if (this.owner.id === Accounts.me().id) {
                data.currentUser = true;
            }
        }
        // This could probably solved more generally by writing a handlebars
        // helper, but for now let's just make sure that empty string values
        // for name get turned into null so that our template will show the ID
        // instead.
        if (_.isString(data.name) && data.name.length===0) { data.name = null; }
        return data;
    },
    // TODO: See views/device.js. Duplicated code, extract. 
    show_settings_generator: function () {
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');

        var devicegroup = this.model.rel.get('devicegroup');

        var show = _.extend({}, SHOW_DEFAULTS, this.getOption('show'));
        var disabled_items = [];

        var is_device_owner = this.model.rel.get('owner') === active;
        // Falsify one value in the show object
        // This will override anything in the defaults or options
        function falsify(key) { show[key] = false; }

        // If assigned to development devicegroup, and is thus a Development Device
        if (devicegroup && devicegroup.type === 'development_devicegroup') {
            disabled_items = ['action_delete'];
            if (!active.permits(primary, 'restart_development_device')) {
                disabled_items.push('action_restart');
                disabled_items.push('action_conditional_restart');
            }
            if (!active.permits(primary, 'update_development_device')) {
                disabled_items.push('action_assign');
            }
            if (!active.permits(primary, 'view_development_deployments')) {
                disabled_items.push('action_code');
            }
            // If assigned to pre_factoryfixture devicegroup, and is thus a Test Factory Fixture
        } else if (devicegroup && devicegroup.type === 'pre_factoryfixture_devicegroup') {
            disabled_items = ['action_delete'];
            if (!active.permits(primary, 'restart_pre_factory_device')) {
                disabled_items.push('action_restart');
                disabled_items.push('action_conditional_restart');
            }
            if (!active.permits(primary, 'update_pre_factory_device')) {
                disabled_items.push('action_assign');
            }
            if (!active.permits(primary, 'delete_pre_factory_device')) {
                disabled_items.push('action_unassign');
            }
            // If assigned to pre_production devicegroup, and is thus a Test Production Device
        } else if (devicegroup && devicegroup.type === 'pre_production_devicegroup') {
            // Unenrolled
            if (!this.model.get('agent_id')) {
                disabled_items = [
                    'action_code',
                    'action_restart',
                    'action_conditional_restart',
                    'action_assign',
                    'action_unassign'
                ];
            // Enrolled
            } else {
                disabled_items = [
                    'action_code',
                    'action_assign',
                    'action_unassign'
                ];
            }
            if (!active.permits(primary, 'restart_pre_production_device')) {
                disabled_items.push('action_restart');
                disabled_items.push('action_conditional_restart');
            }
        } else if (devicegroup && devicegroup.type === 'factoryfixture_devicegroup') {
            disabled_items = [
                'action_code',
                'action_delete'
            ];
            if (!this.model.get('last_enrolled_at') || !active.permits(primary, 'restart_factory_device')) {
                disabled_items.push('action_restart');
                disabled_items.push('action_conditional_restart');
            }
            if (!active.permits(primary, 'update_factory_device')) {
                disabled_items.push('action_assign');
            }

        } else if (devicegroup && devicegroup.type === 'production_devicegroup') {

            disabled_items = [
                'action_code',
                'action_delete',
            ];
            if (!this.model.get('last_enrolled_at') || !active.permits(primary, 'restart_production_device')) {
                disabled_items.push('action_restart');
                disabled_items.push('action_conditional_restart');
            }
            if (!active.permits(primary, 'update_production_device')) {
                disabled_items.push('action_assign');
            }
            // If not assigned to any devicegroup
        } else {
            disabled_items = [
                'action_code',
                'action_restart',
                'action_conditional_restart',
                'action_unassign'
            ];
        }
        // DUTs are special
        if (this.model.get('is_dut') || devicegroup && devicegroup.type === 'pre_dut_devicegroup') {
            disabled_items = [
                'action_edit',
                'action_assign',
                'action_restart',
                'action_conditional_restart',
                'action_unassign',
                'action_delete'
            ];
            show.remove_dut = is_device_owner;
        }


        // Turn off anything we've specified above
        disabled_items.forEach(falsify);
        // A device with no devicegroup cannot be unassigned
        show.action_unassign = show.action_unassign && devicegroup;
        // A user who is not the owner cannot delete a device
        if (!this.model.get('is_dut')) {
            show.action_delete = show.action_delete && is_device_owner;
        }
        return show;
    },
    templateContext: function() {
        var is_dut = this.model.get('is_dut');
        var is_test_blessed = (this.model.get('device_type') === 'Test Production Device') ? true : false;
        return {
            show_human_type: is_dut || this.getOption('show_human_type'),
            is_dut: is_dut,
            is_test_blessed: is_test_blessed,
            human_type: this.model.human_type({'show_enrolled': true}),
            show: this.show_settings_generator(),
        };
    }
});

